/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: NbAuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {

    if (environment.useCookies) {
      return this.canActivateWithCookies(route, state);
    }

    return this.canActivateWithToken(route, state);
  }

  canActivateWithToken(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.isAuthenticated()
      .pipe(
        tap(authenticated => {
          console.log('auth guard called', state.url);
          if (!authenticated) {
            // this.router.navigateByUrl(`/auth/login?redirect=${state.url}`);
            this.router.navigate(['/auth/login'], { queryParams: { redirect: state.url } });
          }
        }),
      );

  }

  canActivateWithCookies (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    
    const raw = localStorage.getItem('currentUser');

    if (!raw) {
      this.router.navigate(['/auth/login'], { queryParams: { redirect: state.url } });
      return false;
    }

    try {
      const currentUser = JSON.parse(raw);

      if (!currentUser?.user) {
        this.router.navigate(['/auth/login'], { queryParams: { redirect: state.url } });
        return false;
      }

      return true;
    } catch (e) {
      this.router.navigate(['/auth/login'], { queryParams: { redirect: state.url } });
      return false;
    }
  }
}
